/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Validation_CpfInputs */

const en_clients_validation_cpf = /** @type {(inputs: Clients_Validation_CpfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a valid CPF.`)
};

const pt_br2_clients_validation_cpf = /** @type {(inputs: Clients_Validation_CpfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informe um CPF válido.`)
};

/**
* | output |
* | --- |
* | "Enter a valid CPF." |
*
* @param {Clients_Validation_CpfInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_validation_cpf = /** @type {((inputs?: Clients_Validation_CpfInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Validation_CpfInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_validation_cpf(inputs)
	return pt_br2_clients_validation_cpf(inputs)
});